import heart from "./../../../img/heart2.png";
import redHeart from "./../../../img/redHeart.png";
import closed from "./../../../img/closed.png";

export const img = { heart, redHeart, closed }